<script>
import { mapState } from 'vuex';
import PopulationPanels from '@/views/Admin/Config/Population/PopulationPanels';

export default {
    components: { PopulationPanels },
    computed: {
        ...mapState('fieldEditor', ['populations', 'name', 'fieldId', 'type', 'options'])
    }
};
</script>

<template>
    <v-card>
        <v-card-title>
            <h2 class="OptionsGroup__title">
                Populations
            </h2>
        </v-card-title>
        <v-card-text>
            <PopulationPanels
                v-if="populations.length > 0"
                :field-id="fieldId"
                :field-type="type"
                :group-type="options.groupFieldType"
            />
            <p v-else>
                This field contains no populations.
            </p>
        </v-card-text>
        <v-divider />
        <v-card-actions>
            <v-spacer />
            <v-btn :to="'/population/create/' + fieldId">
                <v-icon
                    left
                    small
                >
                    fas fa-plus-circle
                </v-icon>
                Add Population
            </v-btn>
        </v-card-actions>
    </v-card>
</template>
